"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClicksCounter = void 0;
var GameVars_1 = require("../../../GameVars");
var BoardManager_1 = require("../BoardManager");
var AchievementsManager_1 = require("../../../AchievementsManager");
var GameConstants_1 = require("../../../GameConstants");
var AudioManager_1 = require("../../../AudioManager");
var GameManager_1 = require("../../../GameManager");
var ClicksCounter = /** @class */ (function (_super) {
    __extends(ClicksCounter, _super);
    function ClicksCounter(scene) {
        var _this = _super.call(this, scene) || this;
        _this.y = GameVars_1.GameVars.gameHeight - 10 * GameVars_1.GameVars.scaleY;
        _this.scaleY = GameVars_1.GameVars.scaleY;
        _this.f1 = 0;
        _this.f2 = 0;
        _this.f3 = 0;
        _this.inflated = false;
        _this.resetMask = false;
        _this.counterImageFill = new Phaser.GameObjects.Image(_this.scene, GameVars_1.GameVars.gameWidth / 2, _this.y, "texture_atlas_1", "cover_fill");
        _this.counterImageFill.setOrigin(.5, 1);
        _this.counterImageFill.scaleY = GameVars_1.GameVars.scaleY;
        _this.scene.add.existing(_this.counterImageFill);
        // LO AÑADIMOS DIRECTAMENTE A LA ESCENA YA QUE NO SE PUEDE 
        // ENMASCARAR CUANDO ESTÁ DENTRO DE UN GRUPO
        _this.clicksCounterImage = new Phaser.GameObjects.Image(_this.scene, GameVars_1.GameVars.gameWidth / 2, _this.y - 4, "texture_atlas_1", "cover");
        _this.clicksCounterImage.setOrigin(.5, 1);
        _this.clicksCounterImage.scaleY = GameVars_1.GameVars.scaleY;
        _this.clicksCounterImage.setInteractive();
        _this.clicksCounterImage.on("pointerdown", _this.onDown, _this);
        _this.scene.add.existing(_this.clicksCounterImage);
        var maskWidth = 140;
        var maskHeight = 120;
        _this.maskShape = new Phaser.GameObjects.Graphics(_this.scene);
        _this.maskShape.fillStyle(0xff0000, .5);
        _this.maskShape.beginPath();
        _this.maskShape.fillRect(-maskWidth / 2, -maskHeight, maskWidth, maskHeight);
        _this.maskShape.x = GameVars_1.GameVars.gameWidth / 2;
        _this.maskShape.y = _this.y - 16;
        _this.maskShape.scaleY = GameVars_1.GameVars.scaleY;
        var mask = _this.maskShape.createGeometryMask();
        _this.clicksCounterImage.setMask(mask);
        _this.clicksLabel = new Phaser.GameObjects.Text(_this.scene, 0, -70, GameVars_1.GameVars.clicks.toString(), { fontFamily: "Baloo", fontSize: "50px", color: "#F5FEDF" });
        _this.clicksLabel.setOrigin(.5);
        _this.clicksLabel.setStroke("#025575", 8);
        _this.add(_this.clicksLabel);
        _this.hand = new Phaser.GameObjects.Image(_this.scene, 120, -90, "texture_atlas_1", "hand_tutorial_2");
        _this.hand.setAngle(-45);
        _this.hand.visible = false;
        _this.add(_this.hand);
        _this.scene.tweens.add({
            targets: _this.hand,
            x: _this.hand.x - 20,
            scaleX: .9,
            scaleY: .9,
            ease: Phaser.Math.Easing.Cubic.In,
            duration: 250,
            repeat: -1,
            yoyo: true
        });
        return _this;
    }
    ClicksCounter.prototype.changeVisible = function (value) {
        this.counterImageFill.visible = value;
        this.clicksCounterImage.visible = value;
    };
    ClicksCounter.prototype.update = function () {
        if (GameVars_1.GameVars.paused) {
            return;
        }
        if (GameVars_1.GameVars.carouselActive) {
            this.f3++;
            if (this.f3 === 20) {
                this.f3 = 0;
                this.clicksLabel.alpha = this.clicksLabel.alpha === 1 ? .5 : 1;
            }
            return;
        }
        this.clicksLabel.alpha = 1;
        if (this.inflated) {
            this.f1++;
            if (this.f1 === 4) {
                this.inflated = false;
                this.setScale(1, GameVars_1.GameVars.scaleY);
                this.counterImageFill.setScale(1, GameVars_1.GameVars.scaleY);
                this.clicksCounterImage.setScale(1, GameVars_1.GameVars.scaleY);
                this.maskShape.scaleY /= ClicksCounter.INFLATED_SCALE;
            }
        }
        if (GameVars_1.GameVars.isFreeCell) {
            this.clicksLabel.text = GameVars_1.GameVars.clicks.toString();
        }
        else {
            this.clicksLabel.text = GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["FULL"];
        }
        var f = (GameVars_1.GameVars.clicksSpawning - GameVars_1.GameVars.clicks) * 60;
        this.f2++;
        if (this.f2 < f) {
            this.f2 = f;
        }
        else if (this.f2 >= 60 * GameVars_1.GameVars.clicksSpawning) {
            this.f2 = 0;
        }
        if (GameVars_1.GameVars.clicks === 10 && !this.resetMask) {
            this.f2 = 0;
            this.resetMask = true;
        }
        else {
            this.resetMask = false;
        }
        if (!GameVars_1.GameVars.isFreeCell) {
            this.f2 = 60 * GameVars_1.GameVars.clicksSpawning;
        }
        this.maskShape.scaleY = this.f2 / (60 * GameVars_1.GameVars.clicksSpawning);
        if (GameVars_1.GameVars.isFreeCell && Date.now() - GameVars_1.GameVars.lastPlayerAction > 10000) {
            this.hand.visible = true;
        }
        else {
            this.hand.visible = false;
        }
    };
    ClicksCounter.prototype.onDown = function () {
        if (GameVars_1.GameVars.gameData.tutorialPhase === 5) {
            BoardManager_1.BoardManager.endTutorial();
        }
        if (GameVars_1.GameVars.paused || this.inflated || !GameVars_1.GameVars.isFreeCell || GameVars_1.GameVars.carouselActive) {
            return;
        }
        GameManager_1.GameManager.updateLastPlayerAction();
        this.inflated = true;
        this.f1 = 0;
        this.setScale(ClicksCounter.INFLATED_SCALE, ClicksCounter.INFLATED_SCALE * GameVars_1.GameVars.scaleY);
        this.counterImageFill.setScale(ClicksCounter.INFLATED_SCALE, ClicksCounter.INFLATED_SCALE * GameVars_1.GameVars.scaleY);
        this.clicksCounterImage.setScale(ClicksCounter.INFLATED_SCALE, ClicksCounter.INFLATED_SCALE * GameVars_1.GameVars.scaleY);
        this.maskShape.scaleY *= ClicksCounter.INFLATED_SCALE;
        AchievementsManager_1.AchievementsManager.updateAchievement(GameConstants_1.GameConstants.ACHIEVEMENTS_TAP);
        BoardManager_1.BoardManager.decreaseClicksCounter();
        AudioManager_1.AudioManager.playSound("tap");
    };
    ClicksCounter.INFLATED_SCALE = 1.05;
    return ClicksCounter;
}(Phaser.GameObjects.Container));
exports.ClicksCounter = ClicksCounter;
